module.exports = __webpack_public_path__ + "static/media/DSC04262.d1819f61.jpg";